import { YapHeaderButton as CBHeaderButton, YapContentValidations, YapAssetImage as CBAssetImage, useYapPageState as useCBPageState, YapContentBuilderIconProviderContext as CBMessageBuilderIconProviderContext } from '@yapstudios/yap-content-builder'
import '@yapstudios/yap-content-builder/dist/index.css'
import {DefaultMessageTemplate } from './CollegeboardTemplateLibrary.js'
import { MessageHeaderComponent, TextComponent, SingleImageComponent, LearnMoreButtonComponent, ActionButtonComponent, RequestInformationButtonComponent, UniversityComponent } from './CollegeboardComponentLibrary.js'

import CBMessageFeedPreview from './CBMessageFeedPreview'
import CBInstitutionPreview from './CBInstitutionPreview'
import { CBSavedListPreview, CBCollegeListPreview } from './CBCollegeListPreview'

import CBMessagePreview from './CBMessagePreview'

import { convertToPage, convertFromPage } from "./MessageConvert.js"
import { avatarPreviews, wordmarkPreviewsLight, wordmarkPreviewsDark, headerPreview } from "./CollegeboardAssetPreviewLibrary.js"
import CBIconProvider from "./CBIconProvider.js"
import { styles, fonts } from "./CBStyles.js"
import { CBMessageBuilder, CBHeader, CBPage, CBAssetCatalog , CBContentPreviewsModal } from './CBMessageBuilder.jsx'
import './styles.css'

/**
 * Message Validations
 */
const CBMessageValidations : Record<string, any> = {}

/**
 * Field required validation
 * CBContentValidations.fieldRequired('fieldName', { component: new TheComponentToValidation() })
 */
CBMessageValidations.fieldRequired = (field, props) => {
    return YapContentValidations.fieldRequired(field, props ?? {})
}

/**
 * Min Length validation
 * CBContentValidations.minimumLengthWarning('fieldName', { length: 100, component: new TheComponentToValidation() })
 */
CBMessageValidations.minimumLengthWarning = YapContentValidations.minimumLengthWarning
CBMessageValidations.minimumLengthError = YapContentValidations.minimumLengthError

/**
 * Max Length validation
 * CBContentValidations.maximumLengthWarning('fieldName', { length: 100,component: new TheComponentToValidation() })
 */
CBMessageValidations.maximumLengthWarning = YapContentValidations.maximumLengthWarning
CBMessageValidations.maximumLengthError = YapContentValidations.maximumLengthError

/**
 * Image Validations
 */
CBMessageValidations.imageDimensionsRequired = YapContentValidations.imageDimensionsRequired
CBMessageValidations.imageDimensionsWarning = YapContentValidations.imageDimensionsWarning
CBMessageValidations.image = YapContentValidations.image

/**
 * Prevent Links validation
 * CBContentValidations.preventLinks('fieldName', { component: new TheComponentToValidation() })
 */
CBMessageValidations.preventLinks = YapContentValidations.preventLinks
CBMessageValidations.requireHTTPSLinks = YapContentValidations.requireHTTPSLinks
CBMessageValidations.urlProtocolsRequired = YapContentValidations.urlProtocolsRequired

//import { allPreviews, CollegeboardAssetPreviewLibrary } from './CollegeboardAssetPreviewLibrary.js';

var CBMessagePreviewLibrary = { avatarPreviews, wordmarkPreviewsLight, wordmarkPreviewsDark, headerPreview }

export {
    CBMessageBuilder,
    CBMessagePreview,
    CBMessageFeedPreview,
    CBCollegeListPreview,
    CBInstitutionPreview,
    CBSavedListPreview,
    CBMessageBuilderIconProviderContext,
    CBAssetCatalog,
    CBPage,
    CBHeader,
    CBHeaderButton,
    CBAssetImage,
    CBContentPreviewsModal,
    CBIconProvider,
    CBMessagePreviewLibrary,
    useCBPageState,
    MessageHeaderComponent, TextComponent, SingleImageComponent, LearnMoreButtonComponent, ActionButtonComponent, RequestInformationButtonComponent, UniversityComponent, CBMessageValidations, DefaultMessageTemplate, convertFromPage, convertToPage
}
